import { render, staticRenderFns } from "./AlertListIndex.vue?vue&type=template&id=06153516&"
import script from "./AlertListIndex.vue?vue&type=script&lang=js&"
export * from "./AlertListIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports